export const SAVE_EMPLOYEE_LIST = 'SAVE_EMPLOYEE_LIST'; 
export const SAVE_EMPLOYEE_DETAILS = 'SAVE_EMPLOYEE_DETAILS';  